'use client';

import { useGetAccountPermissionsQuery } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

/**
 * Prefetches account permissions for the active account so `useAccountPermissions`
 * fragment reads resolve. Web loads this via PrimaryNav and ProjectFinder;
 * integrations routes like /sequences do not mount those surfaces.
 */
export function AccountPermissionsQuery() {
  const accountId = useActiveAccountId();

  useGetAccountPermissionsQuery({
    variables: { accountId: accountId ?? '' },
    skip: !accountId,
  });

  return null;
}
